var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{attrs:{"__list":_vm.dataArray,"__isOnLoad":_vm.isListOnload,"PID":_vm.PID}})
}
var staticRenderFns = []

export { render, staticRenderFns }